import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';

import { Asset, AssetsService, CreateAssetRequest, MonetaryValue } from '../../shared/services/assets.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatTableDataSource } from '@angular/material/table';

import * as _moment from 'moment';
import { FormBuilder, Validators } from '@angular/forms';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-asset-detail',
  templateUrl: './asset-detail.component.html',
  styleUrls: ['./asset-detail.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class AssetDetailComponent implements OnInit {
  displayedColumns: string[] = ['amountCol', 'atCol', 'actCol'];
  asset: Asset = new Asset();
  vaulationsDataSource: MatTableDataSource<MonetaryValue> = new MatTableDataSource<MonetaryValue>();
  assetId: string = "";
  loadingAssets: boolean = false;
  loadingDebts: boolean = false;
  showEditSidenav: boolean = false;
  addEditIndex: number = -1;
  sideNavMode: string = "";
  isEdit = false;
  saving = false;
  deleting = false;

  assetForm = this.formBuilder.group({
    nameCtl: ['', [Validators.required]],
    descriptionCtl: [''],
    isExploratoryCtl: [true],
    purchasePriceCtl: [0, [Validators.required]],
    purchaseDateCtl: [moment(), [Validators.required]],
    depositPriceCtl: [0, [Validators.required]],
    depositDateCtl: [moment(), [Validators.required]]
  });

  valuationForm = this.formBuilder.group({
    valPriceCtl: [0, [Validators.required]],
    valDateCtl: [moment(), [Validators.required]]
  });

  constructor(public dialog: MatDialog, private route: ActivatedRoute, private router: Router, private assetSvc: AssetsService, private location: Location, private formBuilder: FormBuilder, private _snackBar: MatSnackBar) {
    this.route.paramMap.subscribe((params) => {
      if (params.has('assetId')) {
        var id = params.get('assetId');
        if (id != 'create') {
          this.assetId = id as string;
          this.isEdit = true;
        }
      }
    });
  }
  ngOnInit(): void {
    if (this.isEdit) {
      this.loadingAssets = true;
      this.loadingDebts = false;
      this.assetSvc.getAssetById(this.assetId)
        .subscribe(resp => {
          this.asset = resp;
          this.mapAssetToForm(this.asset);
          this.sortValuations();
          this.assetForm.markAsPristine();
          this.loadingAssets = false;
        });
    }
  }

  mapAssetToForm(a: Asset): void {
    this.assetForm.controls.nameCtl.setValue(a.Name);
    this.assetForm.controls.descriptionCtl.setValue(a.Description);
    this.assetForm.controls.isExploratoryCtl.setValue(a.IsExploratory);
    this.assetForm.controls.purchasePriceCtl.setValue(a.PurchasePrice.Amount);
    this.assetForm.controls.purchaseDateCtl.setValue(moment(a.PurchasePrice.At));
    this.assetForm.controls.depositPriceCtl.setValue(a.Deposit.Amount);
    this.assetForm.controls.depositDateCtl.setValue(moment(a.Deposit.At));
  }

  mapFormToAsset(a: Asset): Asset {
    a.Name = this.assetForm.value.nameCtl as string;
    a.Description = this.assetForm.value.descriptionCtl as string;
    a.IsExploratory = this.assetForm.value.isExploratoryCtl as boolean;
    a.PurchasePrice.Amount = this.assetForm.value.purchasePriceCtl as number;
    a.PurchasePrice.At = moment(this.assetForm.value.purchaseDateCtl).toDate();
    a.Deposit.Amount = this.assetForm.value.depositPriceCtl as number;
    a.Deposit.At = moment(this.assetForm.value.depositDateCtl).toDate();
    return a;
  }

  mapValuationToForm(m: MonetaryValue): void {
    this.valuationForm.controls.valPriceCtl.setValue(m.Amount);
    this.valuationForm.controls.valDateCtl.setValue(moment(m.At));
  }

  mapFormToValuation(): MonetaryValue {
    var m = new MonetaryValue();
    m.Amount = this.valuationForm.value.valPriceCtl as number;
    m.At = moment(this.valuationForm.value.valDateCtl).toDate();
    return m;
  }

  monetaryValueDateComparer(a: MonetaryValue, b: MonetaryValue): number {
    var aDate = new Date(a.At);
    var bDate = new Date(b.At);
    return aDate.getTime() - bDate.getTime();
  }

  private getTime(date?: Date) {
    return date != null ? date.getTime() : 0;
  }
  save() {
    this.saving = true;
    this.disableAssetForm(true);
    console.log(this.asset);
    this.asset = this.mapFormToAsset(this.asset);
    if (this.isEdit) {
      this.assetSvc.updateAsset(this.asset).subscribe({
        next: (data: Asset) => {
          this.asset = data;
          this.mapAssetToForm(this.asset);
          this.assetForm.markAsPristine();
          this.saving = false;
          this.disableAssetForm(false);
        },
        error: (error: HttpErrorResponse) => {
          this.saving = false;
          this._snackBar.open("Error occured updating your asset, please try again later.", undefined, { duration: 5000 })
          this.disableAssetForm(false);
        }
      });
    } else {
      var createReq = new CreateAssetRequest();
      createReq.Deposit = this.asset.Deposit;
      createReq.Description = this.asset.Description;
      createReq.Name = this.asset.Name;
      createReq.PurchasePrice = this.asset.PurchasePrice;
      createReq.Valuations = this.asset.Valuations;
      this.assetSvc.createAsset(createReq).subscribe(
        {
          next: (data: Asset) => {
            this.asset = data;
            this.mapAssetToForm(this.asset);
            this.assetForm.markAsPristine();
            this.saving = false;
            this.disableAssetForm(false);
            this.isEdit = true;
            this.router.navigate(['../assets', data.Id]);
          },
          error: (error: HttpErrorResponse) => {
            this.saving = false;
            this.disableAssetForm(false);
            this._snackBar.open("Error occured creating your asset, please try again later.", undefined, { duration: 5000 })
          },
        });
    }
  }

  cancel() {
    this.location.back();
  }

  delete() {
    let dialogRef = this.dialog.open(DialogDeleteAssetDialog);

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.deleting = true;
        this.assetSvc.deleteAsset(this.asset).subscribe(
          {
            next: (x) => {
              this.deleting = false;
              this.cancel();
            },
            error: (error: HttpErrorResponse) => {
              this.deleting = false;
              this._snackBar.open("Error occured deleting your asset, please try again later.", undefined, { duration: 5000 })
            },
          }
        );
      }
    });
  }

  disableAssetForm(disable:boolean) {
    if(disable == true) {
      this.assetForm.controls.nameCtl.disable();
      this.assetForm.controls.descriptionCtl.disable();
      this.assetForm.controls.isExploratoryCtl.disable();
      this.assetForm.controls.purchasePriceCtl.disable();
      this.assetForm.controls.purchaseDateCtl.disable();
      this.assetForm.controls.depositPriceCtl.disable();
      this.assetForm.controls.depositDateCtl.disable();
    } else {
      this.assetForm.controls.nameCtl.enable();
      this.assetForm.controls.descriptionCtl.enable();
      this.assetForm.controls.isExploratoryCtl.enable();
      this.assetForm.controls.purchasePriceCtl.enable();
      this.assetForm.controls.purchaseDateCtl.enable();
      this.assetForm.controls.depositPriceCtl.enable();
      this.assetForm.controls.depositDateCtl.enable();
    }
  }
  
  openSidenav(mode: string, index: number = -1) {
    this.addEditIndex = index;
    this.sideNavMode = mode;

    switch (mode) {
      case "addValuation":
        this.mapValuationToForm(new MonetaryValue());
        break;
      case "editValuation":
        this.mapValuationToForm(this.asset.Valuations[this.addEditIndex]);
        break;
      default:
        break;
    }

    this.showEditSidenav = true;
  }

  saveEditSidenav() {

    switch (this.sideNavMode) {
      case "addValuation":
        this.asset.Valuations.push(this.mapFormToValuation());
        break;
      case "editValuation":
        this.asset.Valuations[this.addEditIndex] = this.mapFormToValuation();
        break;
      default:
        break;
    }
    this.assetForm.markAsDirty();
    this.sortValuations();
    this.showEditSidenav = false;
  }

  closeEditSidenav() {
    this.showEditSidenav = false;
  }

  sortValuations(): void {
    this.asset.Valuations = this.asset.Valuations.sort(this.monetaryValueDateComparer).reverse();
    this.vaulationsDataSource.data = this.asset.Valuations;
  }
}


@Component({
  selector: 'asset-detail-delete-dialog',
  templateUrl: 'asset-detail-delete-dialog.component.html',
})
export class DialogDeleteAssetDialog {
  constructor(public dialogRef: MatDialogRef<DialogDeleteAssetDialog>) { }
}